import boxAnnotationConfig from 'pages/open-course/peerReview/reviewTypes/structured/partTypes/boxAnnotation/viewConfig';
import multiLineInputConfig from 'pages/open-course/peerReview/reviewTypes/structured/partTypes/multiLineInput/viewConfig';
import optionsConfig from 'pages/open-course/peerReview/reviewTypes/structured/partTypes/options/viewConfig';
import singleLineInputConfig from 'pages/open-course/peerReview/reviewTypes/structured/partTypes/singleLineInput/viewConfig';
import yesNoConfig from 'pages/open-course/peerReview/reviewTypes/structured/partTypes/yesNo/viewConfig';

export default {
  yesNo: yesNoConfig,
  options: optionsConfig,
  singleLineInput: singleLineInputConfig,
  multiLineInput: multiLineInputConfig,
  boxViewDocumentAnnotation: boxAnnotationConfig,
};
